import React from 'react';
import styled from 'styled-components';

const ProgressBar = ({ currentIndex, totalPanels, position = 'TOP', buttonColor }) => {
  if (totalPanels <= 1) return null; // Don't show progress bar for single panel forms

  const progressPercentage = ((currentIndex + 1) / totalPanels) * 100;

  return (
    <ProgressBarWrapper position={position}>
      <ProgressBarContainer>
        <ProgressBarFill progress={progressPercentage} buttonColor={buttonColor} />
      </ProgressBarContainer>
      <ProgressBarText>
        {currentIndex + 1} of {totalPanels}
      </ProgressBarText>
    </ProgressBarWrapper>
  );
};

const ProgressBarWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: ${({ position }) => (position === 'TOP' ? '24px' : '0')};
  margin-top: ${({ position }) => (position === 'BOTTOM' ? '24px' : '0')};
  padding: 0 16px;
`;

const ProgressBarContainer = styled('div')`
  width: 100%;
  height: 6px;
  background-color: #e5e5e5;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
`;

const ProgressBarFill = styled('div')`
  height: 100%;
  width: ${({ progress }) => `${progress}%`};
  background-color: ${({ buttonColor }) => buttonColor || '#8927EF'};
  border-radius: 3px;
  transition: width 0.3s ease;
`;

const ProgressBarText = styled('div')`
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
`;

export default ProgressBar;
